import React from "react";
import { Route, Routes } from "react-router-dom";
import "./css/style.css";
import "./css/telphone-input.css";
import CreateEmbassyBooking from "./pages/CreateEmbassyBooking";
import PaymentSummary from "./pages/PaymentSummary";


function App() {
  return (
    <div className="App">
    <Routes>
      <Route path="/" exact element={<CreateEmbassyBooking  />} />      
      <Route path="/embassy" exact element={<CreateEmbassyBooking  />} />
      <Route path="/embassy/:embassycode" exact element={<CreateEmbassyBooking  />} />
      <Route path="/embassy/:embassycode/:servicecode/:refnumber" exact element={<CreateEmbassyBooking  />} />
      <Route path="/embassy/payment-summary" element={<PaymentSummary />} />
      <Route path="/payment-summary" element={<PaymentSummary />} />
    </Routes>
    </div>
  );
}

export default App;
